import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AccountResponse } from "../../types";


type State = {
  token: string | null;
  email: string | null;
  account: AccountResponse | null;
};

const initialState: State = { token: null, email: null, account: null};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthTokens(
      state: State,
      action: PayloadAction<{ token: string}>
    ) {
      state.token = action.payload.token;
    },
    setAccount(state: State, action: PayloadAction<AccountResponse>) {
      state.account = action.payload;
    },
    setEmail(
      state: State,
      action: PayloadAction<{ email: string}>
    ) {
      state.email = action.payload.email;
    },
    logout(state: State) {
      state.account = null;
      state.token = null;
      state.email = null;
    },

  },
});
export const { setEmail, setAccount, logout, setAuthTokens } = authSlice.actions;
export default authSlice.reducer;
